var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2939 15.451C7.44558 15.451 5.13659 13.142 5.13659 10.2936C5.13659 7.44523 7.44558 5.13623 10.2939 5.13623C13.1422 5.13623 15.4512 7.44523 15.4512 10.2936C15.4512 13.142 13.1422 15.451 10.2939 15.451ZM21.1301 18.861L16.9589 14.6899C16.9367 14.6678 16.911 14.6524 16.8878 14.6319C17.7083 13.3869 18.1873 11.8962 18.1873 10.2937C18.1873 5.93406 14.6533 2.3999 10.2937 2.3999C5.93408 2.3999 2.40002 5.93406 2.40002 10.2937C2.40002 14.6531 5.93408 18.1873 10.2937 18.1873C11.8963 18.1873 13.3866 17.7083 14.6315 16.8876C14.6521 16.9108 14.6674 16.9367 14.69 16.9588L18.8612 21.13C19.4878 21.7565 20.5034 21.7565 21.1301 21.13C21.7567 20.5034 21.7567 19.4876 21.1301 18.861Z",
    fill: "inherit"
  })));
}

export default SvgSearch;